import { Descriptions, Divider } from "antd";
import { Typography } from "antd";
import { labelStyle } from "../RequestUtil";

const { Title } = Typography;

const reasonLabels = {
  occupant_change: "점유자 변경 우려",
  sublease: "무단 전대 우려",
  third_party: "제3자 점유 중",
  eviction_prep: "명도소송 준비 중",
  etc: "기타",
  "월세미납": "월세미납",
  "계약만료": "계약만료",
  "계약위반": "계약위반",
  "불법점유": "불법점유",
  "기타사유": "기타사유",
};

const vacatehouseFiledLabels = {
  y: "이미 진행 중",
  preparing: "준비 중",
  n: "아직 아님",
};

const InjunctionRequest = ({ serviceData, requestData }) => {
  const reactiveColumn = {
    xxl: 1,
    xl: 1,
    lg: 1,
    md: 1,
    sm: 1,
    xs: 1,
  };

  const injunctionData = serviceData.injunction || serviceData.vacatehouse;
  const reasons = injunctionData?.reason || [];

  return (
    <>
      <Title level={4} style={{ color: "#001529", marginBottom: 0 }}>
        점유이전금지 가처분
      </Title>
      <Divider style={{ marginTop: 10 }} />
      <div
        style={{
          backgroundColor: "white",
          padding: 15,
          paddingTop: 5,
          marginBottom: 20,
          borderRadius: 5,
        }}
      >
        <Descriptions
          title="가처분 사유"
          bordered
          column={reactiveColumn}
          size={"small"}
          style={{ marginTop: 20, marginBottom: 15 }}
        >
          <Descriptions.Item label="가처분 이유" labelStyle={labelStyle}>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {reasons.map((option, index) => (
                <li key={index}>{reasonLabels[option] || option}</li>
              ))}
            </ul>
          </Descriptions.Item>
          {serviceData.injunction?.reasonEtc && (
            <Descriptions.Item label="기타 사유" labelStyle={labelStyle}>
              {serviceData.injunction.reasonEtc}
            </Descriptions.Item>
          )}
          {serviceData.injunction?.occupantInfo && (
            <Descriptions.Item label="현재 점유자 정보" labelStyle={labelStyle}>
              {serviceData.injunction.occupantInfo}
            </Descriptions.Item>
          )}
          {serviceData.injunction?.targetProperty && (
            <Descriptions.Item label="대상 부동산" labelStyle={labelStyle}>
              {serviceData.injunction.targetProperty}
            </Descriptions.Item>
          )}
          {serviceData.injunction?.vacatehouseFiled && (
            <Descriptions.Item label="명도소송 진행 여부" labelStyle={labelStyle}>
              {vacatehouseFiledLabels[serviceData.injunction.vacatehouseFiled] || "-"}
            </Descriptions.Item>
          )}
          {serviceData.vacatehouse?.certification && (
            <Descriptions.Item label="내용증명 발송 여부" labelStyle={labelStyle}>
              {serviceData.vacatehouse.certification === "y" ? "예" : "아니오"}
            </Descriptions.Item>
          )}
        </Descriptions>

        {serviceData.contract && (
          <Descriptions
            title="임대차 계약 정보"
            bordered
            column={reactiveColumn}
            size={"small"}
            style={{ marginTop: 20, marginBottom: 15 }}
          >
            <Descriptions.Item label="계약 일자" labelStyle={labelStyle}>
              {serviceData.contract.date || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="보증금" labelStyle={labelStyle}>
              {serviceData.contract.deposit?.amount
                ? `${serviceData.contract.deposit.amount.toLocaleString()}원`
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="월세 유무" labelStyle={labelStyle}>
              {serviceData.contract.monthlyRent?.exist === "y" ? "예" : "아니오"}
            </Descriptions.Item>
            {serviceData.contract.monthlyRent?.exist === "y" && (
              <>
                <Descriptions.Item label="월세 금액" labelStyle={labelStyle}>
                  {serviceData.contract.monthlyRent.amount
                    ? `${serviceData.contract.monthlyRent.amount.toLocaleString()}원`
                    : "-"}
                </Descriptions.Item>
                <Descriptions.Item label="월세 지급일" labelStyle={labelStyle}>
                  {serviceData.contract.monthlyRent.date
                    ? `매월 ${serviceData.contract.monthlyRent.date}일`
                    : "-"}
                </Descriptions.Item>
              </>
            )}
            <Descriptions.Item label="목적물 주소" labelStyle={labelStyle}>
              {serviceData.contract.address || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="계약 만료일" labelStyle={labelStyle}>
              {serviceData.contract.endDate || "-"}
            </Descriptions.Item>
          </Descriptions>
        )}

        <Descriptions
          title="추가 정보"
          bordered
          column={reactiveColumn}
          size={"small"}
          style={{ marginTop: 20, marginBottom: 15 }}
        >
          <Descriptions.Item label="상세 내용" labelStyle={labelStyle}>
            {serviceData.description
              ? serviceData.description.split("\n").map((line, idx) => {
                  return (
                    <span key={idx}>
                      {line}
                      <br />
                    </span>
                  );
                })
              : ""}
          </Descriptions.Item>
          <Descriptions.Item label="연락처" labelStyle={labelStyle}>
            {serviceData.contact}
          </Descriptions.Item>
          <Descriptions.Item label="프로모션" labelStyle={labelStyle}>
            {serviceData.promotionCode}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};

export default InjunctionRequest;
